import React, { ChangeEvent } from "react";

import Button from "@common/components/Button/Button";
import Heading from "@common/components/Heading/Heading";
import Option from "@common/components/Option/Option";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { Spinner } from "@common/components/Spinner/Spinner";
import useTestingCoverageMetadataDimensions, {
  MetadataOption,
} from "@main/pages/Release/consumers/useTestingCoverageMetadataDimensions";
import * as MetricDetailsStyled from "main/pages/Release/views/MetricDetails/MetricDetails.styles";
import * as Styled from "main/pages/Release/views/MetricDetails/TestingCoverage/TestingCoverageMetadataDimensions.styles";

export default function TestingCoverageMetadataDimensions() {
  const { metadataOptions, toggleMetadataOption, handleSave, isSaving, isLoading } =
    useTestingCoverageMetadataDimensions();

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div style={{ padding: "3.2rem 0" }}>
      <MetricDetailsStyled.MetricsCard>
        <Heading
          heading3
          marginBottom={24}
        >
          Metadata dimensions
        </Heading>

        <Paragraph marginBottom={24}>
          {"Coverage shows how your tickets are distributed across each dimension and its categories, e.g. 40% from iOS 18, 20% from iOS 17. The same goes for metadata.\n\n" +
            "Turn on the metadata dimensions where values  repeat, like a role or plan type. " +
            "Leave off fields where every metadata value is  different, like a session ID — because distributing 1,000 tickets across 1,000 unique IDs tells you nothing.\n\n" +
            "This only affects Coverage. Nothing else in Shake changes."}
        </Paragraph>

        <Styled.DimensionList>
          {metadataOptions.map((row: MetadataOption) => (
            <MetadataOptionRow
              key={row.key}
              text={row.key}
              enabled={row.enabled}
              handleCheck={(e) => toggleMetadataOption(row.key, e.target.checked)}
            />
          ))}
        </Styled.DimensionList>

        <Button
          type="submit"
          size="small"
          disabled={isSaving}
          onClick={handleSave}
        >
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </MetricDetailsStyled.MetricsCard>
    </div>
  );
}

interface MetadataOptionRowProps {
  text: string;
  enabled: boolean;
  handleCheck: (e: ChangeEvent<HTMLInputElement>) => void;
}

const MetadataOptionRow = ({ text, enabled, handleCheck }: MetadataOptionRowProps) => {
  return (
    <>
      <Option
        label={text}
        checked={enabled}
        handleCheck={handleCheck}
      />
    </>
  );
};
